import { render, staticRenderFns } from "./PhoneTasksListView.vue?vue&type=template&id=bf38a1bc&scoped=true"
import script from "./PhoneTasksListView.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneTasksListView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PhoneTasksListView.vue?vue&type=style&index=0&id=bf38a1bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf38a1bc",
  null
  
)

export default component.exports